//открытие попапа (просмотр картинки)
if(document.querySelector('[data-img-src]')) {
    document.querySelectorAll('[data-img-src]').forEach((el) => {
        el.addEventListener('click', function  popupOpen(event) {
            event.preventDefault();
            let src = event.currentTarget.getAttribute('data-img-src');
            if(document.querySelector('#imagePopup .popup__img')) {
                document.querySelector('#imagePopup .popup__img').setAttribute('src', src);

                setTimeout(() => {
                    document.querySelector('#imagePopup').style.display="flex";
                    document.body.classList.add('oc-hidden');
                }, 200);
            }
        })
    })
}